exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MultiTabEmptyPage{width:100%}.MultiTabEmptyPage.closed{display:none}.MultiTabEmptyPage .empty-page-body,.MultiTabEmptyPage .image-signature{height:100%;width:100%}", ""]);

// exports
